/**
 * UserAgentをpc,sp,tabの形で返す
 *
 * @function isDevice
 * @return {String} pc,sp,tab
 *
 * Use
import isDevice from './functions/_isDevice.js' // UserAgentをpc,sp,tabの形で返す
if(isDevice === 'pc'){

}
 *
 */
const isDevice = (function () {
  const userAgent = navigator.userAgent
  if (
    userAgent.indexOf('iPhone') > 0 ||
    userAgent.indexOf('iPod') > 0 ||
    (userAgent.indexOf('Android') > 0 && userAgent.indexOf('Mobile') > 0)
  ) {
    return 'sp'
  } else if (userAgent.indexOf('iPad') > 0 || userAgent.indexOf('Android') > 0) {
    return 'tab'
  }
  return 'pc'
})()
export default isDevice

// --- Check OS ---
document.addEventListener('DOMContentLoaded', function () {
  const ua = navigator.userAgent.toLowerCase()
  const body = document.body

  if (/android/.test(ua)) {
    body.classList.add('is-android')
  } else if (/iphone|ipad|ipod/.test(ua)) {
    body.classList.add('is-ios')
  }
})

// --- Check video full screen ---
document.addEventListener('fullscreenchange', () => {
  if (document.fullscreenElement) {
    document.body.classList.add('video-fullscreen')
  } else {
    document.body.classList.remove('video-fullscreen')
  }
})
